import $ from 'jquery';

class EmailAcquisition {
    constructor() {
        this.events();
        this.loadActionNetworkJs();
        this.closeEmail = true;
    }

    onLoadJs() {
        window.onload = function () {
            if( document.querySelector('.cookie_expiry') ) {
                let cookieExpireValue = document.querySelector('.cookie_expiry').value;
                if( parseInt( cookieExpireValue ) > 0 ){
                    let days        = parseInt( cookieExpireValue );
                    let date        = new Date(Date.now() + (days*24*60*60*1000));
                    date            = date.toUTCString();
                    document.cookie = "fist_time_popup=true; expires=" + date;
                }
                if( jQuery('#emailAcModal').length ){
                    jQuery('#emailAcModal').modal('show');
                }
            }
        };
        function getCookieValue(cookieName) {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim();
                if( cookie == cookieName )
                {
                return true;
                }
            }
            return false;
        }
    }

    loadActionNetworkJs(){
        document.querySelectorAll('.action-network-url').forEach( (el) => {
            (function(o,u,i,d){
                o.oe=o.oe||function(){(o.oe.q=o.oe.q||[]).push(arguments)};
                o.oSetting={oid:'',osv:6};
                i=u.getElementsByTagName('head')[0];
                d=u.createElement('script');
                d.async=1;;
                d.src=el.getAttribute('data-src');
                i.appendChild(d);
            })(window,document,'scripts','?sv=');
        } );
    }

    closeModal() {
        document.querySelectorAll('.close-modal-email').forEach((el) => {
            el.addEventListener('click', (ec) => {
                const parentDiv = el.closest('.footer-newsletter');
                if(parentDiv){
                    this.closeEmail = false;
                    parentDiv.classList.add('d-none');
                }
                else{
                    jQuery('#emailAcModal').modal('hide');
                }
            });
        });
    }

    OnScrollJs() {
        window.addEventListener('scroll',(event) => {
            const windowHeight = document.documentElement.clientHeight/2;
            if (windowHeight >= 150) {  
                if( document.querySelector('.footer-newsletter') && this.closeEmail ){
                    document.querySelector('.footer-newsletter').classList.remove('d-none');
                    document.querySelector('.footer-newsletter').classList.add('footer-fixed-newsletter');
                }
            }
        });
    }

    events() {
        this.onLoadJs();
        this.closeModal();
        this.OnScrollJs();
    }
}
new EmailAcquisition();
